module.exports = __webpack_public_path__ + "static/img/example-2.70d8e53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/example-2.png
// module id = gsfO
// module chunks = 2